var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0163 29.7297C25.0163 28.8092 25.7625 28.063 26.6829 28.063H53.3333C54.2538 28.063 55 28.8092 55 29.7297V48.6034C55 50.4443 53.5076 51.9367 51.6667 51.9367H28.3333C26.4924 51.9367 25 50.4443 25 48.6034V30.27C25 30.1907 25.0055 30.1126 25.0163 30.0362V29.7297ZM28.3333 33.4359V48.6034H51.6667V33.4365L43.5358 41.5673C41.5832 43.52 38.4174 43.52 36.4648 41.5673L28.3333 33.4359ZM30.9539 31.3424H49.0467L41.1788 39.2103C40.5279 39.8612 39.4726 39.8612 38.8218 39.2103L30.9539 31.3424Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNew);
export default __webpack_public_path__ + "static/media/mailNew.34f4e4ea.svg";
export { ForwardRef as ReactComponent };